import * as moment from 'moment';
import CalendarApi from "../../common/buytickets-api";
import { IBuyTicketsAppState } from "..";
import { updateEvents, eventError, requestBuyTicketsEvents, requestBuyTicketsShowPosterInfo, updateShowInfo } from './buytickets.actions';

/**
 * Generate a key using the input date object.
 * @param date
 */
function generateKey(date: moment.Moment) {
    return `${date.year().toString()},${date.month().toString()}`
}

/**
 * Dispatch this action to get the latest set of events from the API.
 */
export function getEventsFromApi() {
    return (dispatch, getState: () => IBuyTicketsAppState) => {
        const currState = getState();

        if (!currState.calendar.updating) {
            dispatch(requestBuyTicketsEvents());
        }
        return CalendarApi.getEvents(currState.calendar, currState.calendarSettings).then(events => {
            const filteredEvents = events.filter(currState.calendar.filterFunction);
            dispatch(updateEvents(filteredEvents))
        }).catch(err => {
            dispatch(eventError(err));
        });

    }
}

export function getShowInfoFromApi() {
    return (dispatch, getState: () => IBuyTicketsAppState) => {
        const currState = getState();

        if (!currState.calendar.updating) {
            dispatch(requestBuyTicketsShowPosterInfo());
        }
        return CalendarApi.getShowPosterInfo().then(showinfo => {
            dispatch(updateShowInfo(showinfo))
        }).catch(err => {
            dispatch(eventError(err));
        });

    }
}
